var _desc, _rect, _path, _rect2, _path2, _line, _line2, _rect3, _rect4, _rect5, _circle, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Address Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Address and location icon")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 45,
    width: 40,
    height: 40,
    fill: "#F5F0E6",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 45 L50 25 L75 45 Z",
    fill: "#E5DECF",
    stroke: "#E5DECF",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 15,
    width: 4,
    height: 15,
    fill: "#E5DECF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15 L50 10 L54 15 Z",
    fill: "#5F7A61"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 12,
    x2: 50,
    y2: 18,
    stroke: "white",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 15,
    x2: 53,
    y2: 15,
    stroke: "white",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 55,
    width: 8,
    height: 10,
    fill: "#5F7A61"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 55,
    width: 8,
    height: 10,
    fill: "#5F7A61"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 65,
    width: 10,
    height: 20,
    rx: 2,
    fill: "#5F7A61"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 75,
    r: 1,
    fill: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 90,
    x2: 85,
    y2: 90,
    stroke: "#E5DECF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address-icon.60e6ab4af404a6e80f43409a743ae759.svg";
export { ForwardRef as ReactComponent };